import { addRoute } from "./router";
import type { AppSpec } from "./types";

export function registryApp(app: AppSpec) {
  const routerHelper = addRoute(app);
  return {
    routerHelper,
  };
}
